import React from 'react';

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short' });
const nextDay = (d) => { const x = new Date(`${d}T00:00:00`); x.setDate(x.getDate() + 1); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, '0')}-${String(x.getDate()).padStart(2, '0')}`; };

// Split sorted dates into consecutive runs.
export const toRuns = (dates) => [...dates].sort().reduce((runs, d) => {
  const last = runs[runs.length - 1];
  if (last && nextDay(last[last.length - 1]) === d) last.push(d); else runs.push([d]);
  return runs;
}, []);

// Approver view of a separate-dates request: reject whole ranges or single days.
export const GroupDatesSelector = ({ dates, rejected, onChange, editable, testPrefix }) => {
  const toggle = (list) => {
    const allOff = list.every((d) => rejected.includes(d));
    onChange(allOff ? rejected.filter((d) => !list.includes(d)) : [...new Set([...rejected, ...list])]);
  };
  return (
    <div className="space-y-1.5" data-testid={`${testPrefix}-runs`}>
      {toRuns(dates).map((run) => {
        const runOff = run.every((d) => rejected.includes(d));
        return (
          <div key={run[0]} className="flex flex-wrap items-center gap-1" data-testid={`${testPrefix}-run-${run[0]}`}>
            {run.length > 1 && (
              editable ? (
                <button type="button" onClick={() => toggle(run)} title={runOff ? 'Keep this range' : 'Reject this whole range'}
                  className={`text-[10px] px-1.5 py-0.5 rounded border font-medium transition-colors ${runOff ? 'bg-rose-100 border-rose-300 text-rose-700' : 'bg-white border-gray-300 text-gray-600 hover:border-rose-300'}`}
                  data-testid={`${testPrefix}-run-toggle-${run[0]}`}>{fmt(run[0])} – {fmt(run[run.length - 1])} · {run.length}d {runOff ? '✕' : ''}</button>
              ) : <span className="text-[10px] font-medium text-gray-600">{fmt(run[0])} – {fmt(run[run.length - 1])} · {run.length}d</span>
            )}
            {run.map((d) => {
              const off = rejected.includes(d);
              return editable ? (
                <button key={d} type="button" onClick={() => toggle([d])} title={off ? 'Will be rejected — tap to keep' : 'Tap to reject only this day'}
                  className={`px-2 py-0.5 rounded-full border text-[11px] transition-colors ${off ? 'bg-rose-50 border-rose-300 text-rose-700 line-through' : 'bg-emerald-50 border-emerald-200 text-emerald-800'}`}
                  data-testid={`${testPrefix}-toggle-${d}`}>{fmt(d)}</button>
              ) : <span key={d} className="px-2 py-0.5 rounded-full bg-sky-50 border border-sky-200 text-sky-800 text-[11px]">{fmt(d)}</span>;
            })}
          </div>
        );
      })}
    </div>
  );
};
